export default __webpack_public_path__ + "static/media/pingdom.d4918080.svg";